import React from 'react';
import ReactDOM from 'react-dom/client';
import { FirebaseAppProvider } from 'reactfire';
import { GoogleOAuthProvider } from '@react-oauth/google';

import App from './App';

import { firebaseConfig } from './utils/firebase';
import { clientId } from './utils/googleOAuth';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <FirebaseAppProvider firebaseConfig={firebaseConfig} suspense={true}>
        <App />
      </FirebaseAppProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>,
);
